import { v4 as uuidv4 } from "uuid";
import {
  appLightIcon,
  databaseIcon,
  folderIcon,
  lightningIcon,
  settingIcon,
} from "./assets/icons";

export const ROUTES = {
  SIGNUP: "/signup",
  LOGIN: "/",
  HOME: "/home",
  FORGOT_PASSWORD: "/forget-password",
  SET_PASSWORD: "/set-password",
  AUTH_CONFIRMATION: "/auth-confirmation",
  APP_SETTINGS: "/applications/:appId/settings",
  APPLICATIONS: "/applications",
  DATAMODELS: "/data-models",
  DATA_MODEL_ANALYTICS: "/data-models/:dataModelId/analytics",
  DATA_MODEL_COLLECTIONS: "/data-models/:dataModelId/collections",
  DATA_MODEL_DATA: "/data-models/:dataModelId/data",
  DATA_MODEL_SETTINGS: "/data-models/:dataModelId/settings",
  DATA_MODEL_ENDPOINTS: "/data-models/:dataModelId/endpoints",
  DATA_MODEL_SERVICES: "/data-models/:dataModelId/services",
  DATA_MODEL_SERVICE: "/data-models/:dataModelId/services/:serviceId/details",
  DATA_MODEL_TABLE_DATA: "/data-models/:dataModelId/data/:tableId/:tableRef",
  BACKGROUND_TASKS: "/data-models/:dataModelId/background-tasks",
  COLLECTION_DETAILS:
    "/data-models/:dataModelId/collections/:collectionId/details",
  USERS: "/users",
  USERROLES: "/user-roles",
  INVITATIONS: "/invitations",
  API_DOCS: "/data-models/:dataModelId/api-docs",
  MULESOFT: "/mulesoft",
  MULESOFT_GENERATE: "/mulesoft/:integrationId/generate",
  MULESOFT_ENDPOINTS: "/mulesoft/:integrationId/endpoints",
  MULESOFT_SERVICES: "/mulesoft/:integrationId/services",
  MULESOFT_SERVICE: "/mulesoft/:integrationId/services/:serviceId/details",
  MULESOFT_API_DOCS: "/mulesoft/:integrationId/api-docs",
  ORGANIZATION_USERS: "/organizations/:organizationId/users",
  ORGANIZATIONS: "/organizations",
  GITHUB_CALLBACK: "/github_callback",
  DATA_MODEL_SECRETS: "/data-models/:dataModelId/settings/secrets",
  APP_DATA_MODAL: "/applications/:appId/app-data-modal",
  USER_PROFILE: "/profile",
  SELECT_WORKSPACE: "/select-workspace",
  APPLICATION_DEPLOYMENTS_TRACK: "/applications/:appId/deployments",
  DATAMODEL_DEPLOYMENTS_TRACK: "/data-models/:dataModelId/deployments",
  DEVELOPER_CONSOLE: "/developer-console",
  QUERY_TOOL: "/data-models/:dataModelId/queryTool",
};

export const PAGE_OPTIONS = [
  {
    id: uuidv4(),
    name: "List View",
  },
  {
    id: uuidv4(),
    name: "Details View",
  },
  {
    id: uuidv4(),
    name: "Create View",
  },
  {
    id: uuidv4(),
    name: "Blank Page",
  },
];

export const ICON_OPTIONS = [
  {
    id: uuidv4(),
    name: "lightning bolt",
    icon: lightningIcon,
  },
  {
    id: uuidv4(),
    name: "lightning bolt",
    icon: lightningIcon,
  },
];

export const STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  ARCHIVED: "archived",
  SUSPENDED: "suspended",
  FAILURE: "failure",
  IN_PROGRESS: "in_progress",
};

export const PAGE_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
};

export const AWS_AMPLIFY_ROUTES = {
  AUTHENTICATED: "authenticated",
  IDLE: "idle",
  SETUP: "setup",
  SIGNOUT: "signout",
};

export const BADGE_VARIANTS = {
  DANGER: "danger",
  PRIMARY: "primary",
  SECONDARY: "secondary",
  SUCCESS: "success",
  WARNING: "warning",
  VIOLET: "violet",
};

export const MODAL_SIZE = {
  MD: "medium",
  FULL: "fullScreen",
  LG: "largeScreen",
  XL: "extraLarge",
};

export const MODAL_POSITION = {
  TOP: "top",
  CENTER: "center",
};

export const REGEX = {
  SPECIAL_CHARACTERS: "^[^<>!@#$%^&*()\\-=+{}\\[\\]\\|'\":?.,/;`%]*$",
  SPECIAL_CHARACTERS_NUMBERS_WHITESPACES_AT_START: "^[A-Za-z]",
  SPECIAL_CHARACTERS_WHITESPACES_AT_END:
    /^([A-Za-z][A-Za-z0-9_ ]{1,25}[A-Za-z0-9])$/,
  SPECIAL_CHARACTERS_WHITESPACE_IN_BETWEEN: /^\S*$/,
  EMAIL: /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/,
  PASSWORD:
    /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?"()[\]-]{8,25}$/,
  URL: /^\/[a-zA-Z0-9_\-/{}:]*$/,
  PROPERTY_NAME: /^[a-zA-Z_][\w\s]*$/,
  NUMERIC: /^\d+$/,
  FILE_NAME_FROM_URL: /_(.*)/,
  WHITESPACES_AT_START: /^\S/,
  STRING_FIELD: /^"([^"]+)"$|^'([^']+)'$/,
  S3_BUCKET_VALIDATION: /^[A-Za-z][A-Za-z0-9 ]{1,48}[A-Za-z0-9]$/,
  UPDATE_CASE: /([a-z0-9])([A-Z])/g,
  VERSION_FORMAT: /^(\d+)\.(\d+)\.(\d+)$/,
};

export const POPOVER_BUTTONS = {
  DELETE: "Delete",
  DUPLICATE: "Duplicate",
  EDIT: "Edit",
  EXPORT: "Export",
  VIEW: "View",
  IMPERSONATE: "Impersonate",
  OPEN_APP: "Open App",
};

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const RGBA_COLORS = {
  GRID: "rgb(107 114 128)",
  LINE: [
    { bgColor: "rgba(140, 20, 252, 0.15)", brColor: "rgba(140, 20, 252, 1)" },
    { bgColor: "rgba(245, 39, 145,  0.15)", brColor: "rgba(245, 39, 145, 1)" },
  ],
  DEFAULT: {
    bgColor: "rgba(175, 245, 144, 0.15)",
    brColor: "rgba(175, 245, 144, 1)",
  },
};

export const COLOR_TYPES = ["primaryColor", "secondaryColor", "contrast"];

export const PAGE_TYPES = {
  BLANK_PAGE: "Blank Page",
  CREATE_VIEW: "Create View",
  DETAILS_VIEW: "Details View",
  LIST_VIEW: "List View",
};

export const TABS = {
  APPLICATIONS: "applications",
  DATAMODELS: "DataModels",
  USERS: "Users",
  SETTINGS: "Settings",
  APP_DATA_MODAL: "DataModals",
  COLLECTIONS: "Collections",
  MULESOFT: "mulesoft",
};

export const CACHE_KEYS = {
  IS_AUTHENTICATED: "isAuthenticated",
  X_REQUEST_ID: "X-Request-Id",
  ADMIN_ORGANIZATION: "adminOrganization",
  ORGANIZATION: "organization",
};

export const DEFAULT_INT_VALUES = {
  ONE: 1,
  ZERO: 0,
  TWO: 2,
};

export const ALERT_TIMEOUT = 10000;
export const MODAL_TIMEOUT = 1000;
export const EMPTY_STRING = "";
export const EMPTY_ARRAY = [];
export const EMPTY_OBJECT = {};
export const ZERO = 0;
export const ONE = 1;
export const TWO = 2;

export const INDEX = { FIRST: 0, SECOND: 1, THIRD: 2, FOURTH: 3, FIFTH: 4 };
export const UPLOAD_LOGO_SIZE = 10000000;
export const IMAGE_SIZE_EXCEED_MESSAGE = "File size should be less than 10 MB.";
export const IMAGE_INVALID_FORMAT_MESSAGE =
  "Invalid image type. Please upload a PNG, JPG, or JPEG image.";
export const IMAGE_ALLOWED_TYPES = ["image/png", "image/jpg", "image/jpeg"];

export const DEFAULT_LIMIT = 12;
export const SEARCH_DEBOUNCE_TIME = 200;
export const MAX_DRAWER_WIDTH = 400;
export const MIN_DRAWER_WIDTH = 200;

export const FOOTER_CONSTANTS = {
  DATA_MODELS_TITLE: "What is a Data Model?",
  DATA_MODELS_SUBTITLE:
    "A Data Model is a server that hosts your data and database. All paid instances have dedicated resources in terms of CPU, ram, and storage. Each Data Model has it's own virtual container with it's own API and business logic.",
  DATA_MODELS_TABLES_TITLE: "What Are Database Tables?",
  DATA_MODELS_TABLES_SUBTITLE:
    "A Database table is a collection of data stored in a structured format within a database. Each table is made up of rows and columns. The rows in a table represent individual records, and the columns represent the fields of those records. You can drill down from this view into a single table to view the table's rows and columns. Want to add a new table? Go to the collection's tab and create  new collection.",
  COLLECTIONS_TITLE: "What Are Database Collections?",
  COLLECTIONS_SUBTITLE:
    "A collection is similar to a database table in a traditional relational database, but it is more flexible because it can hold a variety of documents with different structures. A collection is the foundational element of your database. Get started by creating one!",
  COLLECTION_TITLE: "What Are Database Properties?",
  COLLECTION_SUBTITLE:
    "In a database, properties are used to store data and can have different data types. The data type of a property determines the kind of data that can be stored in that property.",
  ENDPOINTS_TITLE: "What Are Endpoints?",
  ENDPOINTS_SUBTITLE:
    "Endpoints are the communication channels to access the services provided in applications and through endpoints one can expose their application services and data to outside world.",
  SERVICES_TITLE: "What Are Services?",
  SERVICES_SUBTITLE:
    "Services define applications' business logic graphically and are composed of nodes (actions) and relations (links) between these nodes.",
  BACKGROUND_TASKS_TITLE: "What Are Background Tasks?",
  BACKGROUND_TASKS_SUBTITLE:
    "A background task is a program or process that is designed to run in background, without requiring the user to interact with it. Background tasks are often used to perform maintenance or other tasks that do not require the user's attention, or to perform tasks at a specific time or on a regular schedule.",
};

export const API_RESPONSES = {
  ERROR: "Error",
  SUCCESS: "Success",
};

export const MOUSE_EVENTS = {
  MOUSE_DOWN: "mousedown",
};

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PATCH: "PATCH",
  DELETE: "DELETE",
};

export const BUTTON_TEXT = {
  CONTINUE: "Continue",
  SUBMIT: "Submit",
  HIDE_SWAGGER: "Hide Swagger",
  SHOW_SWAGGER: "Show Swagger",
  CREATE_PROJECT: "Create Project",
};

export const UNDEFINED = "undefined";

export const DATE_FORMATS = {
  MM_DD_YYYY: "MM/DD/YYYY",
  DD_MM_YYYY: "DD/MM/YYYY",
  YYYY_MM_DD: "YYYY/MM/DD",
};

export const LIBRARY_CONSTANTS = {
  APPLICATION: "templates/applications",
  COLLECTIONS: "collections",
  COLLECTION_PROPERTIES: "collectionProperties",
  SERVICES: "services",
  BACKEND_TEMPLATES: "templates/backendTemplates",
};

export const FLAGS = {
  SHOW_APPLICATIONS: "showApplications",
  SHOW_USERS: "showUsers",
  SHOW_DATA_MODELS: "showDataModels",
  SHOW_APPLICATION_SETTINGS: "showApplicationSettings",
  SHOW_COLLECTIONS: "showCollections",
  SHOW_BACKGROUND_TASKS: "showBackgroundTasks",
  SHOW_API_DOCS: "showApiDocs",
  SHOW_DATA: "showData",
  SHOW_DATA_MODEL_SETTINGS: "showDatamodelSettings",
  SHOW_ENDPOINTS: "showEndpoints",
  SHOW_SERVICES: "showServices",
  SHOW_INTEGRATIONS: "showIntegrations",
  SHOW_INVITATIONS: "showInvitations",
  SHOW_USER_ROLES: "showUserRoles",
  SHOW_DRAG_AND_DROP: "showDragAndDrop",
  SHOW_PREVIEW: "showPreview",
  SHOW_MULESOFT_GENERATED_ENDPOINTS: "showMulesoftGeneratedEndpoints",
  SHOW_ORGANIZATIONS: "showOrganizations",
  SHOW_APP_DATA_MODAL: "showAppDataModal",
  SHOW_USER_PROFILE: "showUserProfile",
  SHOW_APPLICATION_DEPLOYMENTS_TRACK: "showApplicationDeploymentsTrack",
  SHOW_DATA_MODEL_DEPLOYMENTS_TRACK: "showDataModelDeploymentsTrack",
  SHOW_DEVELOPER_CONSOLE: "showDeveloperConsole",
  SHOW_QUERY_TOOL: "showQueryTool",
};

export const BOOLEAN = {
  TRUE: "true",
  FALSE: "false",
};

export const DATA_TYPES = {
  STRING: "string",
  OBJECT: "object",
  NUMBER: "number",
  TIMESTAMP: "TIMESTAMP(3) DEFAULT CURRENT_TIMESTAMP",
  VARCHAR: "varchar(255)",
  JSON_MODE: "json",
  TEXT: "text",
  HTML: "html",
  JAVASCRIPT: "javascript",
  SQL: "sql",
};

export const DATA_TYPE_DESCRIPTIONS = [
  "boolean",
  "Json",
  "Multi Line Text",
  "TIMESTAMP(3)",
  "Single Line Text",
  "File",
  "Image",
  "One-to-Many",
  "Number",
  "Dropdown",
];

export const FILE_PROPERTIES = {
  NAME: "name",
  BASE_64_URL: "base64Url",
};

export const HANDLE_TYPES = {
  OBJECT: "object",
  LIST: "list",
  VALUE: "value",
  TRIGGER: "trigger",
};

export const ACE_EDITOR_THEMES = {
  LIGHT: "chrome",
  DARK: "twilight",
};
export const WINDOW_EVENTS = {
  COPY: "copy",
  PASTE: "paste",
  CLICK: "click",
  POPSTATE: "popstate",
};

export const ESCAPE = "Escape";
export const KEYDOWN = "keydown";
export const MULESOFT = "mulesoft";
export const ADMIN = "admin";

export const TIME_TO_ALLOW_REDEPLOY = 300000;

export const REFRESH_DEPLOY_STATUS = 10000;

export const REFRESH_FRONTEND_DEPLOY_STATUS = 5000;

export const APP_DEPLOY_AT = "appDeployAt";

export const DEPLOY_STATUSES = {
  SUCCESS: "success",
  DEPLOY: "deploy",
  RE_DEPLOY: "reDeploy",
  QUEUED: "queued",
  IN_PROGRESS: "in_progress",
  ACTION_REQUIRED: "action_required",
  FAILURE: "failure",
  CANCELLED: "cancelled",
  CREATING_PROJECT: "creating_project",
  REPO_NOT_FOUND: "repo_not_found",
  COMPLETED: "completed",
  SKIPPED: "skipped",
  PENDING: "pending",
};

export const DEPLOY_PIPELINE_STEPS = {
  GENERATING_CODE: "Generating Code",
  PUSHING_TO_GITHUB: "Pushing To GitHub",
  CI_PIPELINE: "CI Pipeline",
  CD_PIPELINE: "CD Pipeline",
  AWS_DEPLOYMENT: "AWS Deployment in progress",
  GCP_DEPLOYMENT: "GCP Deployment in progress",
  CI_CD_PIPELINE: "CI/CD Pipeline in progress",
  DEPLOYMENT: "Deployment Complete",
  BUILD: "Build",
};

const { IN_PROGRESS, QUEUED, FAILURE } = DEPLOY_STATUSES;

export const BACKEND_FAILURE_STATUS = {
  CREATE_PROJECT: { status: FAILURE, steps: [] },
  CI: { status: FAILURE, steps: [] },
  CD: { status: FAILURE, steps: [] },
  AWS: { status: FAILURE, steps: [] },
};

export const FRONTEND_FAILURE_STATUS = {
  CREATE_PROJECT: { status: FAILURE, steps: [] },
  BUILD: { status: FAILURE, steps: [] },
};

export const BACKEND_INITIAL_STATUS = {
  CREATE_PROJECT: { status: IN_PROGRESS, steps: [] },
  CI: { status: QUEUED, steps: [] },
  CD: { status: QUEUED, steps: [] },
  AWS: { status: QUEUED, steps: [] },
};

export const FRONTEND_INITIAL_STATUS = {
  CREATE_PROJECT: { status: IN_PROGRESS, steps: [] },
  BUILD: { status: QUEUED, steps: [] },
};

export const ALL_SERVICE_TYPE_OPTIONS = {
  endpoints: [{ value: "endpoint", name: "Endpoint Service" }],
  "background-tasks": [{ value: "backgroundTask", name: "Background Service" }],
  services: [
    { value: "", name: "Select Service Type" },
    { value: "endpoint", name: "Endpoint Service" },
    { value: "backgroundTask", name: "Background Service" },
    { value: "subflow", name: "Subflow Service" },
  ],
};

export const GITHUB_AUTH_FLOW = {
  PROVIDER: "Provider",
  GITHUB_USER_INFO: "githubUserInfo",
  GITHUB: "Github",
};

export const IMPERSONATED_USER_SUB = "impersonatedUserSub";

export const DEFAULT_LOGO_URL =
  "https://devtavajsapptemplate.s3.ap-south-1.amazonaws.com/trip-tava/logo/tripTavaLogoMin.svg";

export const DEFAULT_BRAND_LOGO_URL =
  "https://devtavajsapptemplate.s3.ap-south-1.amazonaws.com/trip-tava/logo/tripTavaWithBrand.svg";

export const DEPLOY = { FRONTEND: "frontend", BACKEND: "backend" };

export const ENTER_KEY_CODE = 13;

export const DATA_COUNT_OPTIONS = [12, 20, 50, 100];

export const USER_INFO = "userInfo";

export const VALIDATION_MESSAGES = {
  MIN_CHAR_LENGTH: "Minimum three characters are required.",
  MAX_CHAR_LENGTH:
    "Maximum limit of characters should not exceed more than 20.",
  NAME_SHOULD_CONTAIN:
    "Name must not contain numbers, special characters and white spaces at start.",
  APPLICATION_NAME_IS_REQUIRED: "Application name is required.",
  BRAND_NAME_IS_REQUIRED: "Brand name is required.",
  BRAND_NAME_MIN_LENGTH: "Brand name should not be less than 3 characters.",
  BRAND_NAME_MAX_LENGTH: "Brand name should not be more than 20 characters.",
  BACKGROUND_TASK_NAME_IS_REQUIRED: "Background Task name is required.",
  NAME_SHOULD_NOT_CONTAIN:
    'Name must not contain special characters except "_"',
  MAX_CHAR_LENGTH_TWENTY_ONE:
    "Maximum limit of characters should not exceed more than 21.",
  NAME_SHOULD_NOT_CONTAIN_AT_END:
    "Name must not contain white spaces and underscore(_) at the end.",
  NAME_SHOULD_NOT_CONTAIN_WHITESPACE_IN_BETWEEN:
    "Whitespaces are not allowed in between the name.",
  START_DATE_IS__REQUIRED: "Start date is required.",
  FREQUENCY_IS__REQUIRED: "Frequency is required.",
  SERVICE_IS_REQUIRED: "Service is required.",
  CHECK_PROPERTY_NAME: "check-property-name",
  COLLECTION_REQUIRED: "Collection name is required.",
  PRIMARY_KEY: "check-primary-key",
  PRIMARY_KEY_REQUIRED: "Primary Key Field is required.",
  VALID_PRIMARY_KEY: "Please enter a valid Primary Key.",
  DATA_MODAL_NAME_MIN_LENGTH:
    "Database name should not be less than 3 characters.",
  DATA_MODAL_NAME: "Database name is required.",
  SELECT_A_REGION: "Select a Region.",
  ENDPOINT_REQUIRED: "Endpoint name is required.",
  ENDPOINT_URL_REQUIRED:
    "Enter valid Url, URL must start with slash '/' and only numbers, letters, colon ':', underscore '_', dash '-', slashes '/' and curly braces '{}' are allowed.",
  URL_REQUIRED: "Url is required.",
  PROPERTY_REQUIRED: "Property name is required.",
  VALID_PROPERTY_NAME: "Please enter a valid property name.",
  CHECK_REQUIRED_FIELD: "check-required-field",
  DEFAULT_VALUE_REQUIRED: "Default value is required.",
  CHECK_EMAIL: "check-email",
  VALID_EMAIL: "Enter a valid email.",
  VALIDATE_INTEGER: "check-integer-validation",
  INVALID_NUMBER: "Invalid Number",
  INTEGER: "Integer",
  REFERENCE_TABLE_REQUIRED: "Reference Table is required.",
  REFERENCE_TABLE_COLUMN_REQUIRED: "Reference Table Column is required.",
  CHECK_OPTIONS: "check-options",
  VALUE_REQUIRED: "Value can't be empty.",
  CHECK_SELECTED_CHOICES: "check-selected-choices",
  SELECT_A_CHOICE: "Select at least one choice.",
  MAX_CHAR_LENGTH_FIFTY:
    "Maximum limit of characters should not exceed more than 50.",
  NAME_REQUIRED: "Name is required.",
  SECRET_KEY_NAME_REQUIRED: "Secret Key name is required.",
  EXISTS_CHECK: "existsCheck",
  SECRET_KEY_EXIST: "Secret Key is already exist.",
  ENTER_SECRET_KEY: "Enter the secret key.",
  NAME: "name",
  SERVICE_REQUIRED: "Service name is required.",
  CHECK_EXSISTANCE: "check-if-already-exists",
  SERVICE_EXISTS: "Service already exists",
  DESCRIPTION_SHOULD_NOT_CONTAIN:
    "Description must not contain white spaces at start.",
  MATCH_PASSWORD: "Password does not matched.",
  PASSWORD_REQUIRED: "Password is required.",
  DEPLOY_MESSAGE_REQUIRED: "Deploy message is required.",
  PASSWORD_NOT_MATCHED: "Password does not matched.",
  USER_REQUIRED: "User name is required.",
  INVALID_EMAIL: "Invalid email address.",
  EMAIL_REQUIRED: "Email is required.",
  ENTER_DIFFERENT_EMAIL: "Enter a different email.",
  USER_ROLE_REQUIRED: "User role name is required.",
  CURRENT_PASSWORD_REQUIRED: "Current password is required.",
  FIELD_EMPTY: "This field cannot be empty.",
  MIN_PASSWORD_LENGTH: "Password must be of length more than or equal to 8.",
  MAX_PASSWORD_LENGTH: "Password must be of length less than or equal to 16.",
  VALIDATE_PASSWORD: "validate-password",
  PASSWORD_SHOULD_CONTAINS:
    "Password should contain the combination of Uppercase, Lowercase and Number.",
  NEW_OLD_SHOULD_NOT_BE_SAME:
    "New Password should not be same as Current Password.",
  VALIDATE_PASSWORD_SYMBOL: "Password must contain a symbol.",
  CONFIRM_PASSWORD_REQUIRED: "Confirm password is required.",
  NEW_PASS: "newPassword",
  CURRENT_PASS: "currentPassword",
  VALIDATE_AUTHORIZATION: "Enter valid authorization code.",
  ORGANIZATION_REQUIRED: "Organization name is required.",
  ONLY_NUMBERS_ALLOWED: "Only Numbers Are Allowed",
  CODE_MUST_BE: "Code must be numbers only",
  CODE_MIN_LENGTH: "Code must be of minimum six digits.",
  CODE_MAX_LENGTH: "Code must be of maximum six digits.",
  VALIDATE_NAME: "Name must not contain spaces at start.",
  NAME_SHOULD_NOT_CONTAINS: "Name must not contain special characters.",
  VALIDATE_ORGANIZATION_NAME:
    "Organization name must not contain spaces at start.",
  ORGANIZATION_NAME_SHOULD_NOT_CONTAINS:
    "Organization name must not contain special characters.",
  PASSWORD_SHOULD_CONTAIN:
    "Password should contain the combination of Uppercase, Lowercase, Number and Symbol.",
  PASSWORD: "password",
  MAX_CHAR_LENGTH_TWENTY_SEVEN:
    "Maximum limit of characters should not exceed more than 27.",
  TYPE_REQUIRED: "Type is required",
  HOST_REQUIRED: "Host is required",
  PORT_DATA_TYPE: "Port must be numeric",
  PORT_REQUIRED: "Port is required",
  SQL_EXPRESSION_REQUIRED: "Sql expression is required",
  CHECK_SQL_SEMICOLON: "check-sql-semicolon",
  CHECK_SEMICOLON: "Must contain ';' at the end.",
  REQUIRED: "Required",
  SELECT_CLOUD_SERVICE: "Cloud Service is required",
};

export const ALERT_MESSAGES = {
  ENDPOINT_EXISTED: "Endpoint with the same URL and method already exists.",
  EMAIL_SUCCESSFULLY_SENT: "Email has been sent successfully.",
  USER_NOT_INVITED: "User is not invited.",
  EXTENSION_NOT_SUPPORTED: "File extension is not supported.",
  PROPERTY_NAME_MUST_BE_UNIQUE: "Property Name must be unique.",
  DATAMODEL_UPDATED: "Successfully updated Database settings.",
  INVALID_SERVICE_FILE: "Invalid Service File.",
  REQUIRED_FIELDS_ARE_EMPTY: "Required fields are empty.",
  EMAIL_IS_NOT_VALID: "Please enter a valid email address.",
  DATA_SAVED_SUCCESSFULLY: "Data Saved Successfully.",
  PROFILE_UPDATED: "Profile details updated.",
  PROFILE_NOT_UPDATED: "Unable to update profile details.",
  WARNING_MESSAGE:
  "If you intend to import this template, please be aware that existing tables/endpoints may be replaced due to conflicts. If you are comfortable with this and agree, kindly proceed. Alternatively, we recommend creating a new database and importing the template there. Thanks!",
};

export const USER_ROLES = {
  OWNER: "owner",
  ADMIN: "admin",
  USER: "user",
};

export const AUTO_MAPPER_OPERATIONS = {
  MAPPER: {
    ADD: "addMapper",
    EDIT: "editMapper",
    UPDATE: "updateMapper",
    DELETE: "deleteMapper",
  },
  MODIFY_SOURCE: "modifySource",
  MODIFY_RESPONSE: "modifyResponse",
  EDGES: "modifyEdges",
  NODES: "modifyNodes",
  RESET_AUTO_MAPPER: "resetAutoMapper",
  RESET_MAPPER: "resetMapper",
  RESPONSE_NODE: "responseNode",
  SOURCE_NODE: "sourceNode",
  SET_RESPONSE_EXPANDED_KEYS: "setResponseExpandedKeys",
  SHOULD_SHOW_RESPONSE_EDITOR: "shouldShowResponseEditor",
  SHOULD_SHOW_SOURCE_EDITOR: "shouldShowSourceEditor",
  POPULATE_MAPPER: "populateMapper",
  SET_SOURCE_EXPANDED_KEYS: "setSourceExpandedKeys",
};

export const CLOUD_SERVICES = [
  { name: "Amazon Web Services (AWS)", value: "AWS" },
  { name: "Google Cloud Platform (GCP)", value: "GCP" },
];

export const QUESTION_MARK = "?";

export const APP_CREATION = [
  {
    message: "Creating your application using the chosen template.",
    image: folderIcon,
  },
  {
    message: "Getting your environment ready.",
    image: settingIcon,
  },
  {
    message: "Designing your data model.",
    image: databaseIcon,
  },
  {
    message: "Getting your application ready for use.",
    image: appLightIcon,
  },
];

export const DATAMODEL_CREATION = [
  {
    message: "Adding your data model resources",
    image: databaseIcon,
  },
  {
    message: "Getting your data model ready for use.",
    image: appLightIcon,
  },
];

export const COLORS = {
  PRIMARY_COLOR: "primaryColor",
  SECONDARY_COLOR: "secondaryColor",
  CONTRAST: "contrast",
};

export const STAGING = "staging";

export const REQUEST_STATUS = {
  FULFILLED: "fulfilled",
  REJECTED: "rejected",
};

export const AWS_USER_EXCEPTION = "UserNotConfirmedException";
export const LOGIN_ERROR_MESSAGE = "Unable to login. Please try again later.";

export const DATA_TYPE =  "dataType";
export const IS_PRIMARY =  "isPrimary";

export const SELECTED_CHOICES = ".jpeg, .png, .jpg, .gif, .ico, .cur, .jfif, .pjpeg, .pjp, ";
